import { Component } from '@angular/core';
import { SystemSettingService } from '../../services/system-settings.service';
import { ToasterService } from "../../../../common/services/toaster.service";
@Component({
  selector: 'app-web-site-setting-admin-page',
  templateUrl: 'web-site-setting-admin.page.html',
  styleUrls: [
    './web-site-setting-admin.page.scss',
  ]
})
export class WebSiteSettingAdminPage {


  messages:any[];
  deliveryMethods:any[];
  emblemTypes:any[];
  settingsFields:any[];
  emblemsType:any[];
  systemSetting:any[];
  availableDelivery:any[];
  loading:boolean=true ;
  selectedEmblemType: string;
  checkboxColumns: { label: string; checked: boolean }[][] = [];
    constructor(
        private systemSettingService: SystemSettingService,
            private toasterService: ToasterService,
      ) { 
  
    }
 ngOnInit() {
  this.loadData();
   
  }
  async loadData() {
    this.loading=false;
    await this.systemSettingService.getSystemAdminDetail().then((response) => {
        
        this.emblemsType = response?.emblemsType || [];
        const selected = this.emblemsType.find(e => e.isSelected);
        if (selected) {
          this.selectedEmblemType = selected.typeCode;
        }
        this.messages = response?.message || [];
        this.availableDelivery = response?.availableDelivery || [];
        this.systemSetting = response?.systemSetting || {};
      });
        this.loading=true;

    }
  toggleSelection(message: any, event: any) {
    message.isSelected = event.detail.checked;
  }

  async submitForm() {
    this.loading=false;
      const settings = this.systemSetting.map(s => ({
        key: s.name,  
        value: s.data
      }));
    
      const selectedEmblemType = this.selectedEmblemType;

      const selectedDeliveries = this.availableDelivery
        .filter(d => d.isSelected)
        .map(d => d.methodCode);

      const selectedMessages = this.messages
        .filter(m => m.isSelected)
        .map(m => ({  
          key: m.description,  
        value: m.messageCode
      }));

      const settingDetail = {
        settings,
        selectedEmblemType,
        selectedDeliveries,
        selectedMessages
      };
 if (!settingDetail) {
      this.toasterService.presentToast(
        "danger",
        "Error",
        "Please fill out at least one fields."
      );
      this.loading=true;
      return;
    }
    await  this.systemSettingService.updateSystemAdminDetail(settingDetail).then((response) => {
      
      if (response.success === true) {
        this.toasterService.presentToast(
          "primary",
          "The settings were updated.",
          "Success"
        );
      } else {
        this.toasterService.presentToast(
          "danger",
          `Error adding web site setting. ${response}`,
          "Error"
        );
      }
    });

this.loading=true;
  }

}